import {
  msGetAllChildDiscounts,
  msGetAllChildDiscountsRegistration,
  msAddDiscountToRegistration,
  msGetAllChildDiscountsEcdaRegistration,
  msAddDiscountToEcdaRegistration,
  msAddDiscountToChild,
  msRemoveChildDiscount,
  msDeactivateChildDiscount,
  msRemoveChildDiscountForEcdaRegistration,
} from 'services/RegistrationsService';
import {
  msRemoveChildDiscountForRegistration,
  msDeactivateChildDiscountForRegistration,
  msDeactivateChildDiscountForEcdaRegistration,
  msGetAllApplicableEnquiryDiscounts,
  msGetAllApplicableEnquiryDiscountsEcda,
  msGetAllApplicableChildDiscounts,
} from 'services/FinanceService';
import { get } from 'lodash';
import {
  FETCH_DISCOUNT_GROUPS,
  FETCH_DISCOUNT_OPTIONS_CONFIG,
  FETCH_ALL_APPLICABLE_CHILD_DISCOUNTS,
  FETCH_ALL_CHILD_DISCOUNTS,
  ACTION_REMOVE_CHILD_DISCOUNT,
  ACTION_DEACTIVATE_CHILD_DISCOUNT,
  FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS,
  FETCH_ALL_CHILD_DISCOUNTS_REGISTRATION,
  FETCH_ALL_CHILD_DISCOUNTS_ECDA_REGISTRATION,
  FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS_ECDA,
} from './actionTypes';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { actionHandlerWithFeatureFlag, parseGraphQLError } from '../../utils';
import {
  GET_ALL_DISCOUNT_GROUPS,
  ACTIVATE_DISCOUNT,
  DEACTIVATE_DISCOUNT,
  GET_OPTIONS_CONFIG_FOR_DISCOUNT,
  ADD_NEW_DISCOUNT_GROUP,
  FETCH_ALL_APPLICABLE_CHILD_DISCOUNTS_ITEMS,
  FIND_ALL_CHILD_DISCOUNTS,
  ADD_DISCOUNT_ITEM_TO_CHILD,
  REMOVE_CHILD_DISCOUNT,
  DEACTIVATE_CHILD_DISCOUNT,
  CHANGE_OBSELETE_DATE_CHILD_DISCOUNT,
  FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS_ITEMS,
  ADD_DISCOUNT_ITEM_TO_REGISTRATION,
  FIND_ALL_CHILD_DISCOUNTS_REGISTRATION,
  REMOVE_CHILD_DISCOUNT_FOR_REGISTRATION,
  DEACTIVATE_CHILD_DISCOUNT_FOR_REGISTRATION,
  FIND_ALL_CHILD_DISCOUNTS_ECDA_REGISTRATION,
  FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS_ITEMS_ECDA,
  ADD_DISCOUNT_ITEM_TO_ECDA_REGISTRATION,
  REMOVE_CHILD_DISCOUNT_FOR_ECDA_REGISTRATION,
  DEACTIVATE_CHILD_DISCOUNT_FOR_ECDA_REGISTRATION,
} from '../models/discountModels';
import DatadogHandler from '../../utils/datadog';
import { FEATURE_FLAGS } from '../../utils/constants';
import {
  msFetchDiscountGroups,
  msDeactivateDiscount,
  msActivateDiscount,
  msAddNewDiscountGroup,
  msChangeObsoleteDateChildDiscount,
} from '../../services/DiscountService';

const fileName = 'src/redux/actions/Registration/Payment.js';

const dispatchGetAllApplicableChildDiscounts = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_APPLICABLE_CHILD_DISCOUNTS,
    key: 'allApplicableChildDiscounts',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetAllApplicableEnquiryDiscounts = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS,
    key: 'allApplicableRegistrationDiscounts',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetAllApplicableEnquiryDiscountsEcda = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS_ECDA,
    key: 'allApplicableEcdaRegistrationDiscounts',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetAllChildDiscounts = (
  dispatch,
  inProgress = true,
  data,
  error = null
) => {
  dispatch({
    type: FETCH_ALL_CHILD_DISCOUNTS,
    key: 'discount',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetAllChildDiscountsRegistration = (
  dispatch,
  inProgress = true,
  data,
  error = null
) => {
  dispatch({
    type: FETCH_ALL_CHILD_DISCOUNTS_REGISTRATION,
    key: 'discountRegistration',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetAllChildDiscountsEcdaRegistration = (
  dispatch,
  inProgress = true,
  data,
  error = null
) => {
  dispatch({
    type: FETCH_ALL_CHILD_DISCOUNTS_ECDA_REGISTRATION,
    key: 'discountEcdaRegistration',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchDiscountGroups = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_DISCOUNT_GROUPS,
    key: 'discountGroups',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetDiscountOptionConfig = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_DISCOUNT_OPTIONS_CONFIG,
    key: 'discountOptionConfig',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchRemoveChildDiscount = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: ACTION_REMOVE_CHILD_DISCOUNT,
    key: 'removeChildDiscoutConfig',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchDeactivateChildDiscount = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: ACTION_DEACTIVATE_CHILD_DISCOUNT,
    key: 'deactivateChildDiscoutConfig',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoAddDiscountToChild = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: ADD_DISCOUNT_ITEM_TO_CHILD,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoAddDiscountToChild',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const addDiscountToChild = reqData => async dispatch => {
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msAddDiscountToChild,
      monoHandler: monoAddDiscountToChild,
      extraData: reqData,
    }
  );

  return data;
};

export const monoAddDiscountToRegistration = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: ADD_DISCOUNT_ITEM_TO_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {
      fileName,
      functionName: 'monoAddDiscountToRegistration',
    });
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const addDiscountToRegistration = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msAddDiscountToRegistration,
      monoHandler: monoAddDiscountToRegistration,
      extraData: reqData,
    }
  );
};

export const monoAddDiscountToEcdaRegistration = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: ADD_DISCOUNT_ITEM_TO_ECDA_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {
      fileName,
      functionName: 'monoAddDiscountToEcdaRegistration',
    });
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const addDiscountToEcdaRegistration = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msAddDiscountToEcdaRegistration,
      monoHandler: monoAddDiscountToEcdaRegistration,
      extraData: reqData,
    }
  );
};

export const monoGetAllChildDiscounts = async childID => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CHILD_DISCOUNTS,
        variables: { childID },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllChildDiscounts',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getAllChildDiscounts = childID => async dispatch => {
  dispatchGetAllChildDiscounts(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetAllChildDiscounts,
      monoHandler: monoGetAllChildDiscounts,
      extraData: { childID },
    }
  );
  if (data.success) {
    dispatchGetAllChildDiscounts(dispatch, false, data.data);
  } else {
    dispatchGetAllChildDiscounts(dispatch, false, null, data.error);
  }

  return data;
};

export const monoGetAllChildDiscountsRegistration = async (_, reqData) => {
  try {
    const registrationChildID = get(reqData, 'registrationChildID');
    const filter = get(reqData, 'filter', {});
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CHILD_DISCOUNTS_REGISTRATION,
        variables: { registrationChildID, filter },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllChildDiscountsRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getAllChildDiscountsRegistration =
  (registrationChildID, filter = {}) =>
  async dispatch => {
    dispatchGetAllChildDiscountsRegistration(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllChildDiscountsRegistration,
        monoHandler: monoGetAllChildDiscountsRegistration,
        extraData: { registrationChildID, filter },
      }
    );

    if (data.success) {
      dispatchGetAllChildDiscountsRegistration(dispatch, false, data.data);
    } else {
      dispatchGetAllChildDiscountsRegistration(
        dispatch,
        false,
        null,
        data.error
      );
    }

    return data;
  };

export const monoGetAllChildDiscountsEcdaRegistration = async (_, reqData) => {
  try {
    const registrationChildID = get(reqData, 'registrationChildID');
    return SkApolloRequest({
      params: {
        query: FIND_ALL_CHILD_DISCOUNTS_ECDA_REGISTRATION,
        variables: { registrationChildID },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllChildDiscountsEcdaRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getAllChildDiscountsEcdaRegistration =
  registrationChildID => async dispatch => {
    dispatchGetAllChildDiscountsEcdaRegistration(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllChildDiscountsEcdaRegistration,
        monoHandler: monoGetAllChildDiscountsEcdaRegistration,
        extraData: { registrationChildID },
      }
    );

    if (data.success) {
      dispatchGetAllChildDiscountsEcdaRegistration(dispatch, false, data.data);
    } else {
      dispatchGetAllChildDiscountsEcdaRegistration(
        dispatch,
        false,
        null,
        data.error
      );
    }

    return data;
  };

export const monoGetAllApplicableChildDiscounts = async (_, childID) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FETCH_ALL_APPLICABLE_CHILD_DISCOUNTS_ITEMS,
        variables: {
          childID,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    throw parseGraphQLError(ex);
  }
};

export const getAllApplicableChildDiscounts = childID => async dispatch => {
  dispatchGetAllApplicableChildDiscounts(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllApplicableChildDiscounts,
        monoHandler: monoGetAllApplicableChildDiscounts,
        extraData: childID,
      }
    );

    if (data.success) {
      dispatchGetAllApplicableChildDiscounts(dispatch, false, data.data);
    } else {
      dispatchGetAllApplicableChildDiscounts(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchGetAllApplicableChildDiscounts(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
    return ex;
  }
};

export const monoGetAllApplicableEnquiryDiscounts = async (_, reqData) => {
  try {
    const registrationChildID = get(reqData, 'registrationChildID');
    const data = await SkApolloRequest({
      params: {
        query: FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS_ITEMS,
        variables: {
          registrationChildID,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllApplicableEnquiryDiscounts',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getAllApplicableEnquiryDiscounts =
  registrationChildID => async dispatch => {
    dispatchGetAllApplicableEnquiryDiscounts(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllApplicableEnquiryDiscounts,
        monoHandler: monoGetAllApplicableEnquiryDiscounts,
        extraData: { registrationChildID },
      }
    );

    if (data.success) {
      dispatchGetAllApplicableEnquiryDiscounts(dispatch, false, data.data);
    } else {
      dispatchGetAllApplicableEnquiryDiscounts(
        dispatch,
        false,
        null,
        data.error
      );
    }

    return data;
  };

export const monoGetAllApplicableEnquiryDiscountsEcda = async (_, reqData) => {
  try {
    const registrationChildID = get(reqData, 'registrationChildID');
    return SkApolloRequest({
      params: {
        query: FETCH_ALL_APPLICABLE_ENQUIRY_DISCOUNTS_ITEMS_ECDA,
        variables: {
          registrationChildID,
        },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllApplicableEnquiryDiscountsEcda',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getAllApplicableEnquiryDiscountsEcda =
  registrationChildID => async dispatch => {
    dispatchGetAllApplicableEnquiryDiscountsEcda(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllApplicableEnquiryDiscountsEcda,
        monoHandler: monoGetAllApplicableEnquiryDiscountsEcda,
        extraData: { registrationChildID },
      }
    );

    if (data.success) {
      dispatchGetAllApplicableEnquiryDiscountsEcda(dispatch, false, data.data);
    } else {
      dispatchGetAllApplicableEnquiryDiscountsEcda(
        dispatch,
        false,
        null,
        data.error
      );
    }

    return data;
  };

export const monoFetchDiscountGroups = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_ALL_DISCOUNT_GROUPS,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    dispatchFetchDiscountGroups(dispatch, false, null, {
      error: ex.message,
    });
    return ex;
  }
};

export const fetchDiscountGroups = reqData => async dispatch => {
  dispatchFetchDiscountGroups(dispatch);

  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msFetchDiscountGroups,
        monoHandler: monoFetchDiscountGroups,
        extraData: reqData,
        dispatch,
      }
    );

    if (data.success) {
      dispatchFetchDiscountGroups(dispatch, false, data.data);
    } else {
      dispatchFetchDiscountGroups(dispatch, false, null, data.error);
    }

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoActivateDiscount = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: ACTIVATE_DISCOUNT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    return ex;
  }
};

export const activateDiscount = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msActivateDiscount,
    monoHandler: monoActivateDiscount,
    extraData: reqData,
  });

export const monoDeactivateDiscount = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: DEACTIVATE_DISCOUNT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    return ex;
  }
};

export const deactivateDiscount = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msDeactivateDiscount,
    monoHandler: monoDeactivateDiscount,
    extraData: reqData,
  });

export const monoAddNewDiscountGroup = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: ADD_NEW_DISCOUNT_GROUP,
        variables: {
          discountItemGroupData: reqData,
        },
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    return parseGraphQLError(ex);
  }
};

export const addNewDiscountGroup = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msAddNewDiscountGroup,
    monoHandler: monoAddNewDiscountGroup,
    extraData: reqData,
  });

export const fetchDiscountOptionConfig = schoolID => async dispatch => {
  dispatchGetDiscountOptionConfig(dispatch);

  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_OPTIONS_CONFIG_FOR_DISCOUNT,
        variables: {
          filter: {
            fkSchool: schoolID,
          },
        },
      },
      type: 'query',
    });
    if (result.success) {
      dispatchGetDiscountOptionConfig(dispatch, false, result.data);
    } else {
      dispatchGetDiscountOptionConfig(dispatch, false, null, result.error);
    }
  } catch (ex) {
    dispatchGetDiscountOptionConfig(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const monoRemoveChildDiscount = async (_, reqData) => {
  try {
    const { childID, discountArrangementId, remarks } = reqData;

    return SkApolloRequest({
      params: {
        mutation: REMOVE_CHILD_DISCOUNT,
        variables: {
          childID,
          discountArrangementId,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoRemoveChildDiscount',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const removeChildDiscount =
  (childID, remarks, discountArrangementId) => async dispatch => {
    dispatchRemoveChildDiscount(dispatch);

    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msRemoveChildDiscount,
        monoHandler: monoRemoveChildDiscount,
        extraData: { childID, discountArrangementId, remarks },
      }
    );

    if (data.success) {
      dispatchRemoveChildDiscount(dispatch, false, data.data);
    } else {
      dispatchRemoveChildDiscount(dispatch, false, null, data.error);
    }

    return data;
  };

export const monoRemoveChildDiscountForRegistration = async (_, reqData) => {
  try {
    const { registrationChildID, remarks, discountArrangementId } = reqData;
    const data = await SkApolloRequest({
      params: {
        mutation: REMOVE_CHILD_DISCOUNT_FOR_REGISTRATION,
        variables: {
          registrationChildID,
          discountArrangementId,
          remarks,
        },
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {
      functionName: 'monoRemoveChildDiscountForRegistration',
      fileName,
    });
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const removeChildDiscountForRegistration =
  (registrationChildID, remarks, discountArrangementId) => () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msRemoveChildDiscountForRegistration,
        monoHandler: monoRemoveChildDiscountForRegistration,
        extraData: { registrationChildID, remarks, discountArrangementId },
      }
    );
  };

export const monoRemoveChildDiscountForEcdaRegistration = async (
  _,
  reqData
) => {
  try {
    const { registrationChildID, remarks, discountArrangementId } = reqData;
    return SkApolloRequest({
      params: {
        mutation: REMOVE_CHILD_DISCOUNT_FOR_ECDA_REGISTRATION,
        variables: {
          registrationChildID,
          discountArrangementId,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {
      functionName: 'monoRemoveChildDiscountForEcdaRegistration',
      fileName,
    });
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const removeChildDiscountForEcdaRegistration =
  (registrationChildID, remarks, discountArrangementId) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msRemoveChildDiscountForEcdaRegistration,
        monoHandler: monoRemoveChildDiscountForEcdaRegistration,
        extraData: { registrationChildID, remarks, discountArrangementId },
      }
    );
  };

export const monoDeactivateChildDiscountForRegistration = async (
  _,
  reqData
) => {
  try {
    const { registrationChildID, discountArrangementId, remarks } = reqData;

    return SkApolloRequest({
      params: {
        mutation: DEACTIVATE_CHILD_DISCOUNT_FOR_REGISTRATION,
        variables: {
          registrationChildID,
          discountArrangementId,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoDeactivateChildDiscountForRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const deactivateChildDiscountForRegistration =
  (registrationChildID, remarks, discountArrangementId) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msDeactivateChildDiscountForRegistration,
        monoHandler: monoDeactivateChildDiscountForRegistration,
        extraData: { registrationChildID, discountArrangementId, remarks },
      }
    );
  };

export const monoDeactivateChildDiscountForEcdaRegistration = async (
  _,
  reqData
) => {
  try {
    const { registrationChildID, discountArrangementId, remarks } = reqData;

    return SkApolloRequest({
      params: {
        mutation: DEACTIVATE_CHILD_DISCOUNT_FOR_ECDA_REGISTRATION,
        variables: {
          registrationChildID,
          discountArrangementId,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoDeactivateChildDiscountForEcdaRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const deactivateChildDiscountForEcdaRegistration =
  (registrationChildID, remarks, discountArrangementId) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msDeactivateChildDiscountForEcdaRegistration,
        monoHandler: monoDeactivateChildDiscountForEcdaRegistration,
        extraData: { registrationChildID, discountArrangementId, remarks },
      }
    );
  };

export const monoDeactivateChildDiscount = async (_, reqData) => {
  try {
    const { childID, discountArrangementId, remarks } = reqData;

    return SkApolloRequest({
      params: {
        mutation: DEACTIVATE_CHILD_DISCOUNT,
        variables: {
          childID,
          discountArrangementId,
          remarks,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoDeactivateChildDiscount',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const deactivateChildDiscount =
  (childID, remarks, discountArrangementId) => async dispatch => {
    dispatchDeactivateChildDiscount(dispatch);

    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msDeactivateChildDiscount,
        monoHandler: monoDeactivateChildDiscount,
        extraData: { childID, discountArrangementId, remarks },
      }
    );

    if (data.success) {
      dispatchDeactivateChildDiscount(dispatch, false, data.data);
    } else {
      dispatchDeactivateChildDiscount(dispatch, false, null, data.error);
    }

    return data;
  };

export const monoChangeObsoleteDateChildDiscount = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CHANGE_OBSELETE_DATE_CHILD_DISCOUNT,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const changeObsoleteDateChildDiscount = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msChangeObsoleteDateChildDiscount,
      monoHandler: monoChangeObsoleteDateChildDiscount,
      extraData: reqData,
    }
  );
};
